import type {
  AuthPermissionAction,
  AuthPermissionResource,
  AuthPermissionScopeDimension,
  AuthUserOrganizationType,
  AuthUserRelationType,
} from "@/lib/api/authUsers/users";

const permissionResourceLabels: Record<AuthPermissionResource, string> = {
  market_analysis: "Market Analysis",
  risk_management: "Risk Management",
  freight_ticket_upload: "Freight Ticket Upload",
  weight_ticket: "Weight Ticket",
  signals: "Signals",
};

function titleCase(value: string): string {
  return value.split("_").map((word) => word.charAt(0).toUpperCase() + word.slice(1)).join(" ");
}

/** Falls back to the key for a resource the portal doesn't know yet. */
export function permissionResourceLabel(resource: AuthPermissionResource): string {
  return permissionResourceLabels[resource] ?? titleCase(resource);
}

export const actionLabels: Record<AuthPermissionAction, string> = {
  read: "View",
  create: "Create",
  update: "Update",
  delete: "Delete",
};

export function actionsLabel(actions: readonly AuthPermissionAction[]): string {
  return actions.length > 0 ? actions.join(", ") : "none";
}

export const organizationTypeLabels: Record<AuthUserOrganizationType, string> = {
  client: "client",
  non_client: "non-client",
};

export const relationTypeLabels: Record<AuthUserRelationType, string> = {
  risk: "Risk",
  freight: "Freight",
  weight_ticket: "Weight ticket",
};

export const scopeDimensionLabels: Record<AuthPermissionScopeDimension, string> = {
  commodity_group: "Commodity groups",
};

/** e.g. "kansas_city_wheat" → "Kansas City Wheat". */
export function scopeValueLabel(value: string): string {
  return titleCase(value);
}
